import { Controller } from "@hotwired/stimulus";

/**
 * 出金申請ページの申請額のチェックボックスのコントローラー
 * チェック時には入力フィールドを無効化し、チェックを外すと有効化する
 * amountValue には出金可能額の最大値が入る
 * また、チェックを外すと、入力フィールドに入力されていた値を保持しておき、再度チェックを入れた際にその値を入力フィールドにセットする
 */
export class PayoutRequestsCheckboxController extends Controller {
  static targets = ["checkBox", "inputField"];
  static values = { amount: Number };

  stock = 0;

  connect() {
    this.check();
  }

  check() {
    if (this.checkBoxTarget.checked) {
      this.inputFieldTarget.disabled = true;
      this.stock = this.inputFieldTarget.value;
      this.inputFieldTarget.value = this.amountValue;
    } else {
      this.inputFieldTarget.disabled = false;
      this.inputFieldTarget.value = this.stock === 0 ? "" : this.stock;
    }
  }
}